import { ballTypeValues, divisionFormatTypeIds, EventVerifiedTypes } from '../../../../utils/eventConstants';
import { errorMessage } from '../../../../utils/displayMessageConstants';

const showSpecificDateError = `Please add at least one division date or disable the "Prevent same-date multiple division registrations" setting to continue.`;

export const validateCancellationDate = (value, selfWithdrawEnabled) => {
    if (selfWithdrawEnabled) {
        return {
            error: value ? null : `Select Max cancellation date`,
        };
    }
};

export const validateMaxRefundDate = (value, maxRefundDateEnabled) => {
    if (maxRefundDateEnabled) {
        return {
            error: value ? null : `Select Max auto-refund date`,
        };
    }
};

export const validateSpecialDivisionDate = (value, specificDivisionDateEnabled, showDateError) => {
    if (showDateError) {
        return {
            error: value ? null : showSpecificDateError,
        };
    }
    if (specificDivisionDateEnabled) {
        return {
            error: value ? null : `This field is required.`,
        };
    }
    if (!showDateError) {
        return {
            error: null,
        };
    }
};

export const validateFees = (
    value,
    minimumEntryFee,
    currencySymbol,
    minimumVerifiedEntryFee,
    isVerifiedEvent,
    clubTierTypeId,
) => {
    if (minimumEntryFee) {
        if (isVerifiedEvent && minimumVerifiedEntryFee > 0 && clubTierTypeId !== 7) {
            const minimumFee = Math.max(minimumEntryFee, minimumVerifiedEntryFee);
            return {
                error: value && /^\d+(\.\d+)?$/.test(value) && value >= minimumFee ? null : `Fee has not reached the minimum of ${currencySymbol}${parseInt(minimumFee)}.`,
            };
        }
        return {
            error: !value || value === '0' || (value && value >= minimumEntryFee) ? null : `Fee should be ${currencySymbol}0 or at least ${currencySymbol}${minimumEntryFee}.`,
        };
    }
    // Legacy logic, might not be needed
    if (isVerifiedEvent) {
        return {
            error: (!value && minimumVerifiedEntryFee === 0) || (value && /^\d+$/.test(value) && value >= minimumVerifiedEntryFee)
                ? null : `Fee must be at least ${currencySymbol}${parseInt(minimumVerifiedEntryFee)} (whole number).`,
        };
    }
    return {
        error: !value || value === '0' || (value && /^\d+$/.test(value) && value >= 5) ? null : `Fee should be ${currencySymbol}0 or at least ${currencySymbol}5 (whole number).`,
    };
};

export const validateMinEntryFee = (
    value,
    isVerified,
    minimumEntryFee,
    allowZeroEntryFee,
    minimumOrZeroEntryFeeErrorMessage,
    minimumEntryFeeErrorMessage,
) => {
    // Normalize input
    const numericValue = value == null || value === ''
        ? null
        : Number(value);

    const isEmptyOrZero = numericValue === null || numericValue === 0;

    // RULE 1:
    // Non-verified events → zero (or empty) is always allowed
    if (!isVerified && isEmptyOrZero) {
        return { error: null };
    }

    // RULE 2:
    // Verified events → zero (or empty) is allowed ONLY if allowZeroEntryFee === true
    if (isVerified && isEmptyOrZero) {
        return {
            error: allowZeroEntryFee ? null : minimumEntryFeeErrorMessage,
        };
    }

    // RULE 3:
    // Any non-zero value must meet the minimum entry fee
    if (numericValue < minimumEntryFee) {
        return {
            error: allowZeroEntryFee || !isVerified
                ? minimumOrZeroEntryFeeErrorMessage
                : minimumEntryFeeErrorMessage,
        };
    }

    return { error: null };
};

export const hasDinglesDivisions = (eventDivisions = []) => {
    return eventDivisions.some((div) => {
        if (div?.divisionFormatType == null) {
            return false;
        }
        return Number(div.divisionFormatType) === divisionFormatTypeIds.DINGLES;
    });
};

export const validateVerifiedEvent = (value, eventDivisions) => {
    if (value === null || value === undefined || value === '') {
        return {
            error: 'This field is required.',
        };
    }

    if (value === EventVerifiedTypes.UnVerified.toString() && eventDivisions.length > 0) {
        // For the Non verified event checking ballType value. If the ballType value is Red or Orange or Green then need to show an error message.
        if (eventDivisions.some(div => (div.ballTypeValue && div.ballTypeValue !== ballTypeValues.YELLOW))) {
            return {
                error: errorMessage.eventTypeErrorMessage,
            };
        }
    }

    return null;
};

export const checkRemainingDivisionsBallTypeValue = (divisions, existingEventTypeSelection) => {
    if (divisions.length === 0 || (divisions.length > 0 && (divisions.every(div => ((div.ballTypeValue === ballTypeValues.YELLOW || !div.ballTypeValue) || (div.ballTypeValue === ballTypeValues.YELLOW && !div.ballTypeValue)))))) {
        return validateVerifiedEvent(existingEventTypeSelection, divisions);
    }

    return undefined;
};
